export default __webpack_public_path__ + "static/media/bg1-desktop.86394c5a.png";